import React from 'react';

import './style.scss';

interface ISpinnerProps {
    className?: string;
    variant?: string;
    size?: 'sm' | 'md' | 'lg';
}

export const Spinner = ({className, variant, size}: ISpinnerProps) => {
    let classNameComputed = 'Spinner';
    if (className) {
        classNameComputed += ` ${className}`;
    }
    if (variant) {
        classNameComputed += ` Spinner--${variant}`;
    }
    if (size) {
        classNameComputed += ` Spinner--${size}`;
    }
    return (
        <i className={classNameComputed}/>
    );
};

Spinner.defaultProps = {
    size: 'md'
};
